import { render, staticRenderFns } from "./FighterCategoryEdit.vue?vue&type=template&id=2305eb18&lang=pug"
import script from "./FighterCategoryEdit.vue?vue&type=script&lang=js"
export * from "./FighterCategoryEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports